module.exports = __webpack_public_path__ + "static/img/marke11.ba5ab30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/marke11.jpg
// module id = C5SQ
// module chunks = 0